import _isString from 'lodash/isString'

import React from 'react'

import { Logger } from 'cube'
import { classToFComponent, type FCClassContext, ViewSlot } from 'cube-react'

import { type IMenuItem } from '@govbr-ds/core'
import { BrMenu, type BrMenuProps, Col } from '@govbr-ds/react-components'

import { MenuScope, MenuItem } from '../main.scope'

const LOG = Logger.get('main/Menu')

type MenuProps = {
    className?: string
    scope: MenuScope
}

class MenuViewClass implements FCClassContext<MenuProps> {
    scope!: MenuScope

    menuVersion = -1
    menuData: IMenuItem[] = []

    render({ scope }: MenuProps) {
        this.scope = scope

        if (this.menuVersion !== scope.version) {
            this.menuData = this.#loadMenuData(scope.items)
            this.menuVersion !== scope.version
        }

        return (
            <BrMenu
                closable
                shadow
                showFooter
                type={scope.type}
                startActive={scope.active}
                md={scope.size}
                lg={scope.size}
                xl={scope.size}
                systemName="BulaCerta AI"
                id="main-navigation"
                data={this.menuData}
                externalLinks={[
                    {
                        link: 'https://www.lifeshub.com.br/',
                        label: 'Lifeshub Official'
                    },
                    {
                        link: 'https://www.lifeshub.com.br/contato',
                        label: 'Suporte Técnico'
                    }
                ]}
                socialNetworks={[
                    {
                        link: 'https://www.linkedin.com/company/lifeshub/',
                        icon: 'fab fa-linkedin-in',
                        name: 'Linkedin'
                    },
                    {
                        link: 'https://www.instagram.com/lifeshub/',
                        icon: 'fab fa-instagram',
                        name: 'Instagram'
                    }
                ]}
                info={
                    <Col>
                        <div className="text-center" style={{ fontSize: '0.8rem', color: '#666' }}>
                            Desenvolvido por <strong>Lifeshub Group</strong>
                            <br />© 2025 Todos os direitos reservados.
                        </div>
                    </Col>
                }
            />
        )
    }

    #loadMenuData(src: MenuItem[]) {
        const tgt: BrMenuProps['data'] = []

        for (let i = 0; i < src.length; i++) {
            const srcItem = src[i]
            const tgtItem = (tgt[i] = {} as IMenuItem)

            if (_isString(srcItem.label)) {
                tgtItem.label = srcItem.label
            } else if (srcItem.label) {
                tgtItem.label = <ViewSlot scope={srcItem.label} />
            }

            tgtItem.icon = srcItem.icon
            tgtItem.divider = srcItem.divider
            tgtItem.expanded = srcItem.expanded
            tgtItem.active = srcItem.active
            tgtItem.danger = srcItem.danger
            tgtItem.keepMenuActive = srcItem.keepMenuActive

            if (srcItem.onClick) {
                tgtItem.onClick = () => srcItem.onClick().catch(LOG.caught)
            }

            if (srcItem.submenu) {
                tgtItem.submenu = this.#loadMenuData(srcItem.submenu)
            }
        }
        return tgt
    }
}

export default classToFComponent<MenuProps>(MenuViewClass)
